'use client';
import { useState, useEffect } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import MobileMenu from './MobileMenu';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const doSearch = () => {
    if (searchQuery.trim()) {
      router.push(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <>
      <header
        className={`sticky top-0 z-[150] bg-white border-b-[3px] border-[#0D0D0D] h-14 flex items-center transition-shadow duration-200 ${
          scrolled ? 'shadow-[0_2px_12px_rgba(0,0,0,0.10)]' : ''
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-5 w-full flex items-center justify-between">
          {/* Logo */}
          <Link href="/" className="flex items-end gap-0 shrink-0">
            <span className="bg-[#C8102E] text-white font-['Playfair_Display',Georgia,serif] font-black text-[22px] px-3.5 py-1.5 leading-none">
              VERITAS
            </span>
            <span className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[9px] tracking-[0.18em] text-[#6B6B6B] uppercase ml-2.5 pb-0.5">
              NEWS
            </span>
          </Link>

          {/* Search - hidden on mobile */}
          <div className="hidden md:flex border border-[1.5px] border-[#D4D4D4] focus-within:border-[#0D0D0D] transition-colors">
            <input
              type="text"
              placeholder="Search stories, topics..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && doSearch()}
              className="font-['IBM_Plex_Sans',system-ui,sans-serif] text-[13px] px-3 py-1.5 w-[220px] focus:outline-none bg-transparent"
            />
            <button
              onClick={doSearch}
              className="bg-[#1A1A1A] text-white px-3.5 text-[13px] hover:bg-[#C8102E] transition-colors flex items-center"
              aria-label="Search"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
              </svg>
            </button>
          </div>

          {/* Right actions */}
          <div className="flex items-center gap-2">
            <button className="hidden md:block border border-[#D4D4D4] px-3.5 py-1.5 font-['IBM_Plex_Sans',system-ui,sans-serif] font-semibold text-[13px] text-[#0D0D0D] hover:border-[#0D0D0D] transition-colors">
              Sign In
            </button>
            <Link
              href="/newsletters"
              className="hidden md:block bg-[#C8102E] text-white px-4 py-1.5 font-['IBM_Plex_Sans',system-ui,sans-serif] font-semibold text-[13px] hover:bg-[#9E0C23] transition-colors"
            >
              Subscribe
            </Link>
            {/* Hamburger */}
            <button
              onClick={() => setIsMenuOpen(true)}
              className="md:hidden p-2 text-[#0D0D0D]"
              aria-label="Open menu"
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6"/>
                <line x1="3" y1="12" x2="21" y2="12"/>
                <line x1="3" y1="18" x2="21" y2="18"/>
              </svg>
            </button>
          </div>
        </div>
      </header>
      <MobileMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
}
